import React, { useState, useEffect } from "react";
import { PaymentService, EventApplicationService,GlobalSettingService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { useParams, useLocation, Link } from "react-router-dom";
import PaymentCard from "../Common/PaymentCard";
import HeaderLogo from "../../components/Logo/HeaderLogo";
import { routes } from "../../constants/routes";
import { toast } from "react-toastify";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { handleConsoleError } from "../../utils/common-methods";

const PayoutDatePayment = (props) => {
  const { token } = useParams();
  const location = useLocation();

  const [paymentDetails, setPaymentDetails] = useState();
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const getData = async () => {
      props.application.setLoading(true);

      try {
        const part = location?.pathname?.includes("initial") ? 1 : 2;

        const res = await PaymentService.getPaymentDetailsById(token, part);

        if (res?.isSuccess && res?.data) {
          const details = {
            ...res?.data,
            isFinalPayment: part !== 1,
            traderId: res?.data?.usersId,
            appId: res?.data?.applicationId,
            connectedAccountId: JSON.parse(res?.data?.request)?.connectedAccountId,
            initial: part === 1 ? false : false, // redundant but explicit
          };

          if (part === 1) {
            details.IsCaterer = await IsCatererApp(res?.data?.applicationId);
            details.isFinalPayment = false;
            // details.amount =
            //   (res?.data?.amount || 0) + (res?.data?.applicationFee || 0);
            //100% payment changes
            details.amount =
              (res?.data?.amount || 0) +
              (res?.data?.applicationFee || 0) +
              (res?.data?.remainingAmount || 0);
            details.remainingAmount = 0;
          }

          setPaymentDetails(details);
          try {
              const res = await GlobalSettingService.getStripeDetails();
          if (res?.isSuccess && res?.data) {
            const stripe = await loadStripe(
              `${GlobalSettingService.decrypt(res?.data?.keyValue)}`, // safer than hardcoding
              { stripeAccount: details?.connectedAccountId } // "acct_1Rxk0OPj32pqn1XA"
            );
            setStripePromise(stripe);
          }
          } catch (error) {
           const message= handleConsoleError(error);
            toast.error(error?.message|| message);
          }
        } else {
          toast.success("Already paid");
          // navigate(routes.DEFAULT);
        }
      } catch (error) {
       const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      } finally {
        props.application.setLoading(false);
      }
    };

    getData();
  }, [token, location.pathname]);

  const IsCatererApp = async (id) => {
    try {
      const res = await EventApplicationService.getCaterApplicationById(id);
      if (res?.isSuccess) {
        return true;
      } else {
        // setCaterInitialValue();
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  return (
    <Elements stripe={stripePromise}>
      <React.Fragment>
        <section className="loginswallow">
          <div
            className="form-container"
            id="form-container"
            style={{ margin: "100px auto" }}
          >
            <div className="row mb-3">
              <div className="col-sm-2"></div>
              <div className="col-sm-8">
                <Link to={routes.DEFAULT} className="link-dark ">
                  <HeaderLogo className="mb-3"></HeaderLogo>
                </Link>
              </div>
              <div className="col-sm-2"></div>
            </div>
            {/* <HeaderLogo className="mb-3"></HeaderLogo>{" "} */}
            {paymentDetails && (
              <PaymentCard paymentDetails={paymentDetails}></PaymentCard>
            )}
          </div>
        </section>
      </React.Fragment>
    </Elements>
  );
};
export default injectModels(["auth", "application"])(PayoutDatePayment);
